var toS = require('./toS')
var isStringPrimitive = require('./stringPrimitive')

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @since 3.0.0
 * @category Lang
 *
 * @memberOf is
 * @extends isStringPrimitive
 * @variation also allows String objects
 *
 * @param {*} x The value to check.
 * @return {boolean} Returns `true` if `value` is a string, else `false`.
 *
 * @see https://github.com/lodash/lodash/blob/master/isString.js
 * @see isStringPrimitive
 *
 * @example
 *
 * isString('abc')
 * // => true
 *
 * isString(new String('abc'))
 * // => true
 *
 * isString(1)
 * // => false
 */
module.exports = function (x) { return isStringPrimitive(x) || toS(x) === '[object String]'; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5nLmpzIiwic291cmNlcyI6WyJzdHJpbmcuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgdG9TID0gcmVxdWlyZSgnLi90b1MnKVxuY29uc3QgaXNTdHJpbmdQcmltaXRpdmUgPSByZXF1aXJlKCcuL3N0cmluZ1ByaW1pdGl2ZScpXG5cbi8qKlxuICogQ2hlY2tzIGlmIGB2YWx1ZWAgaXMgY2xhc3NpZmllZCBhcyBhIGBTdHJpbmdgIHByaW1pdGl2ZSBvciBvYmplY3QuXG4gKlxuICogQHNpbmNlIDMuMC4wXG4gKiBAY2F0ZWdvcnkgTGFuZ1xuICpcbiAqIEBtZW1iZXJPZiBpc1xuICogQGV4dGVuZHMgaXNTdHJpbmdQcmltaXRpdmVcbiAqIEB2YXJpYXRpb24gYWxzbyBhbGxvd3MgU3RyaW5nIG9iamVjdHNcbiAqXG4gKiBAcGFyYW0geyp9IHggVGhlIHZhbHVlIHRvIGNoZWNrLlxuICogQHJldHVybiB7Ym9vbGVhbn0gUmV0dXJucyBgdHJ1ZWAgaWYgYHZhbHVlYCBpcyBhIHN0cmluZywgZWxzZSBgZmFsc2VgLlxuICpcbiAqIEBzZWUgaHR0cHM6Ly9naXRodWIuY29tL2xvZGFzaC9sb2Rhc2gvYmxvYi9tYXN0ZXIvaXNTdHJpbmcuanNcbiAqIEBzZWUgaXNTdHJpbmdQcmltaXRpdmVcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqIGlzU3RyaW5nKCdhYmMnKVxuICogLy8gPT4gdHJ1ZVxuICpcbiAqIGlzU3RyaW5nKG5ldyBTdHJpbmcoJ2FiYycpKVxuICogLy8gPT4gdHJ1ZVxuICpcbiAqIGlzU3RyaW5nKDEpXG4gKiAvLyA9PiBmYWxzZVxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4gaXNTdHJpbmdQcmltaXRpdmUoeCkgfHwgdG9TKHgpID09PSAnW29iamVjdCBTdHJpbmddJ1xuIl0sIm5hbWVzIjpbImNvbnN0Il0sIm1hcHBpbmdzIjoiQUFBQUEsR0FBSyxDQUFDLEdBQUcsR0FBRyxPQUFPLENBQUMsT0FBTyxDQUFDO0FBQzVCQSxHQUFLLENBQUMsaUJBQWlCLEdBQUcsT0FBTyxDQUFDLG1CQUFtQixDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQTZCdEQsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFBLENBQUMsQ0FBQSxDQUFDLEFBQUcsU0FBQSxpQkFBaUIsQ0FBQyxDQUFDLENBQUMsSUFBSSxHQUFHLENBQUMsQ0FBQyxDQUFDLEtBQUssaUJBQWlCLEdBQUE7In0=